import { useExperiment } from '../hooks/use-experiment';

export function usePriceCardExperiment() {
  const experiment = useExperiment();
  return experiment?.ab_price_card_2025;
}
